import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function PhotoDeleteConfirmPopup({ show, onCancel, onConfirm }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-delete-confirm-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onCancel}
        >
          <motion.div
            className="photo-delete-confirm-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="photo-delete-confirm-popup-header">
              <h3 className="photo-delete-confirm-popup-title">이미지 삭제</h3>
            </div>
            <div className="photo-delete-confirm-popup-content">
              <p className="photo-delete-confirm-popup-message">이미지를 삭제하시겠습니까?</p>
              <div className="photo-delete-confirm-popup-buttons">
                <button className="photo-delete-confirm-btn-cancel" onClick={onCancel}>
                  취소
                </button>
                <button className="photo-delete-confirm-btn-confirm" onClick={onConfirm}>
                  확인
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


